var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "#090C10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10016_6333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0656 70.9763C57.1409 71.5196 55.9965 71.5279 55.064 70.998L47.2466 66.5563L64.2002 56.808V24.5961L70.9948 28.4566C72.5586 29.3452 73.5247 31.0052 73.5247 32.8039V59.0325C73.5247 60.8053 72.586 62.4456 71.0575 63.3436L58.0656 70.9763Z",
    fill: "url(#paint0_linear_10016_6333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0015 59.2071C18.0015 60.9999 18.9613 62.6555 20.5172 63.5463L43.2882 76.5831C44.8221 77.4613 46.7057 77.4644 48.2425 76.5912L55.0876 72.702L27.326 56.5961V37.0994L18.0015 42.3974V59.2071Z",
    fill: "url(#paint1_linear_10016_6333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7167 23.7483V34.3444L45.7631 24.596L18.0015 40.702V32.9857C18.0015 31.2031 18.9505 29.5554 20.4924 28.6608L43.2651 15.4492C44.8108 14.5525 46.7175 14.5488 48.2666 15.4395L62.7167 23.7483Z",
    fill: "#FACE68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3127 42.3974C42.5842 41.3378 44.0677 40.702 45.763 40.702C51.6968 40.702 56.3591 45.3643 56.3591 51.298C56.3591 57.2318 51.6968 62.106 45.763 62.106C39.8293 62.106 34.9551 57.4437 34.9551 51.51V32.649L41.3127 29.0464V42.3974ZM48.9418 54.6888C49.7895 53.8411 50.2134 52.7815 50.2134 51.51C50.2134 48.9669 48.3061 47.0596 45.763 47.0596C44.4915 47.0596 43.4319 47.4835 42.5842 48.3312C41.7365 49.1788 41.3127 50.2384 41.3127 51.51C41.3127 54.053 43.22 55.9603 45.763 55.9603C46.8226 55.9603 48.0942 55.5365 48.9418 54.6888Z",
    fill: "url(#paint2_linear_10016_6333)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10016_6333",
    x1: 55.9496,
    y1: 70.7725,
    x2: 87.6396,
    y2: 49.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBB432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C14D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10016_6333",
    x1: 18.6581,
    y1: 42.6542,
    x2: 48.1748,
    y2: 76.0754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F0BD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB12C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10016_6333",
    x1: 52.1147,
    y1: 62.481,
    x2: 25.4624,
    y2: 43.5494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F0BD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F0BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F4C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6C658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C95D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10016_6333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.5264,
    height: 64,
    fill: "white",
    transform: "translate(18 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiture);
export default __webpack_public_path__ + "static/media/Biture.57fd62356e85cf7df17ae2ed3323cde8.svg";
export { ForwardRef as ReactComponent };